import { gql } from "graphql-request";

export const CREATE_CONTACT = gql`
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      id
      firstName
      lastName
      email
      phone
      jobTitle
      companyID
      companyName
      source
      referredByName
      preferredCommsMethod
      notes
      status
      engagementLevel
      fitScore
    }
  }
`;

export const UPDATE_CONTACT = gql`
  mutation UpdateContact($input: UpdateContactInput!) {
    updateContact(input: $input) {
      id
      firstName
      lastName
      email
      phone
      jobTitle
      companyName
      companyID
      status
      source
      referredByContactID
      referredByName
      preferredCommsMethod
      notes
      engagementLevel
      fitScore
      lastInteractionAt
      lastMeaningfulTouchAt
      relationshipScore
      atRisk
      nextFollowUpAt
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const ARCHIVE_CONTACT = gql`
  mutation ArchiveContact($id: ID!) {
    archiveContact(id: $id)
  }
`;